import { render, staticRenderFns } from "./NotificationPetugasTMA.vue?vue&type=template&id=55929e2e&"
import script from "./NotificationPetugasTMA.vue?vue&type=script&lang=js&"
export * from "./NotificationPetugasTMA.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports